<script setup lang="ts">
import { computed } from 'vue';
import { useLocale } from '@/plugins/translation';
import { ContentTypes, ContentTypeSelectHeader } from '@ilteducation/components';
import type { ContentTypeOption } from '@ilteducation/components';

const { t, l } = useLocale();

const model = defineModel<ContentTypes>({ default: ContentTypes.Video });

type Emits = {
  (e: 'close'): void;
};
const emit = defineEmits<Emits>();

const options = computed<ContentTypeOption<ContentTypes>[]>(() => [
  { name: t(l.videos.title), value: ContentTypes.Video, icon: 'fa:fal fa-video', color: 'primary' },
  { name: t(l.articles, 2), value: ContentTypes.Article, icon: 'fa:fal fa-newspaper', color: 'tertiary' },
  { name: t(l.tabs.materials), value: ContentTypes.Material, icon: 'fa:fal fa-file-lines', color: 'primary' },
]);
</script>

<template>
  <ContentTypeSelectHeader
    v-model="model"
    :title="t(l.components.message_add_new_content)"
    :options="options"
    @close="emit('close')"
  />
</template>
